import ElementChart from './ElementChart.vue';
export { ElementChart };
